import {
  CallToAction,
  Image,
  TabItem,
  UIEvent
} from '@com-delta-idp/mnx-ui-kit';
import { OfferBanner } from '../../models';
import { creditSummary } from '../offer-credit/content.mocks';

export const callToActionButtonMocks: CallToAction = {
  input: 'button',
  link: {
    label: 'Apply now',
    url: 'https://qwww.americanexpress.com/us/credit-cards/card-application/apply/partner/cop/ifrmdapp/personal-card/dal/delta-skymiles-gold-american-express-card/ep-daltslgout'
  },
  message: {
    title: '',
    subtitle:
      'Apply for the Delta SkyMiles<sup>&#174;</sup> Gold American Express Card'
  }
};

export const callToActionMocks: CallToAction = {
  input: 'checkbox',
  link: {
    label: '',
    url: 'https://qwww.americanexpress.com/us/credit-cards/card-application/apply/partner/cop/ifrmdapp/personal-card/dal/delta-skymiles-gold-american-express-card/ep-daltslgout'
  },
  message: {
    title:
      'Apply for the Delta SkyMiles<sup>&#174;</sup> Gold American Express Card',
    subtitle: ''
  },
  enable: undefined
};

export const offerImage: Image = {
  src: 'https://origin-pqgemapp.americanexpress.com/content/dam/platformexcellence_internet/cardart/delta-skymiles-gold-american-express-card.png',
  alt: 'Delta SkyMiles Gold American Express Card'
};

export const linksEnrollment: TabItem[] = [
  {
    tabId: 0,
    tabDescription: 'Benefit Terms',
    url: 'https://qwww.americanexpress.com/us/credit-cards/card-application/apply/partner/print/cop/purpa-lin/personal-card/dal/delta-skymiles-gold-american-express-card/ep-daltslgout?print=false#benefit-terms'
  }
];

export const links: TabItem[] = [
  {
    tabId: 0,
    tabDescription: 'Rates & Fees',
    url: 'https://qwww.americanexpress.com/us/credit-cards/card-application/apply/partner/print/cop/purpa-lin/personal-card/dal/delta-skymiles-gold-american-express-card/ep-daltslgout?print=false'
  },
  {
    tabId: 1,
    tabDescription: 'Offer Terms',
    url: 'https://qwww.americanexpress.com/us/credit-cards/card-application/apply/partner/print/cop/purpa-lin/personal-card/dal/delta-skymiles-gold-american-express-card/ep-daltslgout?print=false#offer-terms'
  },
  {
    tabId: 2,
    tabDescription: 'Benefit Terms',
    url: 'https://qwww.americanexpress.com/us/credit-cards/card-application/apply/partner/print/cop/purpa-lin/personal-card/dal/delta-skymiles-gold-american-express-card/ep-daltslgout?print=false#benefit-terms'
  }
];

export const offerBanner: OfferBanner = {
  action: callToActionMocks,
  annualFee: '$0 introductory annual fee for the first year, then $95',
  benefit: 'Plus enjoy your first checked bag free on Delta Flights',
  details:
    '*Statement credit issued approximately 8-12 weeks after you make a Delta purchase on your Card in your first 3 months. Bonus miles will be issued after you make $1,000 in purchases on your new Card in your first 3 months. Terms and Conditions Apply.',
  headline: 'LIMITED TIME OFFER',
  image: offerImage,
  links,
  offer: 'Earn a $200 Statement Credit and 20,000 Bonus Miles*',
  pageId: 'trip-summary-rev',
  summary: creditSummary
};

export const uiEventMocks: UIEvent = {
  currentTarget: '',
  target: '',
  value: '',
  type: ''
};
